import { z } from "zod";

// Step 1: Basic Info Schema
export const basicInfoSchema = z.object({
  name: z.string().min(2, "Store name must be at least 2 characters"),
  legalName: z.string().min(2, "Legal name is required"),
  address: z.string().optional(),
  street: z.string().optional(),
  streetNumber: z.string().optional(),
  city: z.string().min(2, "City is required"),
  zip: z.string().min(5, "Postal code is required"),
  state: z.string().optional(),
  phone: z.string().min(5, "Phone number is required"),
  email: z.string().email("Invalid email address"),
  companyPhone: z.string().min(5, "Company phone number is required"),
});

// Step 2: Legal & Fiscal Schema
export const legalFiscalSchema = z.object({
  taxId: z.string().min(9, "Tax ID (USt-IdNr.) is required").max(11),
  businessType: z.enum([
    "einzelunternehmen",
    "gbr",
    "ohg",
    "kg",
    "gmbh",
    "ag",
    "ug",
    "other",
  ]),
  registrationNumber: z
    .string()
    .min(1, "Commercial register number (Handelsregisternummer) is required"),
  taxOffice: z.string().min(1, "Tax office (Finanzamt) is required"),
  hasVatExemption: z.boolean().default(false),
  acceptTerms: z.boolean().refine((val) => val === true, {
    message: "You must accept the terms and conditions",
  }),
});

// Step 3: B2B Requirements Schema
export const b2bSchema = z.object({
  isB2B: z.boolean().default(true),
  industryType: z.enum(
    [
      "restaurant",
      "cafe",
      "bar",
      "nightclub",
      "hotel",
      "spa",
      "salon",
      "tattoo",
      "massage_therapy",
      "catering",
      "retail",
      "fitness",
      "beauty",
      "healthcare",
      "education",
      "other",
    ],
    {
      required_error: "Industry type is required",
    }
  ),
  taxExemptionCertificate: z.boolean().default(false),
  gdprCompliance: z.boolean().refine((val) => val === true, {
    message: "GDPR compliance is required for operation in Germany",
  }),
});

// Combined schema for all steps
export const formSchema = z.object({
  ...basicInfoSchema.shape,
  ...legalFiscalSchema.shape,
  ...b2bSchema.shape,
});

export type CreateStoreFormData = z.infer<typeof formSchema>;
